// src/encounter/lib/referral-edit-seed.ts
// [PROD-1395 / PROD-3336] What the referral dialog opens with: an EDIT seeds from the saved payload (a speciality referral
// keeps its speciality, a PROD-1395 role referral its role, and both their practitioner), a NEW referral from the dragged /
// picked search item. PURE, so the edit round trip is testable
// without mounting the A&P view.
import type { CodeSearchResult } from '@scripsteam/scrips-signal-ds';
import type { CodedOrderPayload } from './order-payload';
import type { ReferralTargetInput } from './to-referral-order';
import type { ReferralPractitioner } from './referral-practitioners';

export interface ReferralDialogSeed {
  target?: ReferralTargetInput;
  initialPractitioner?: ReferralPractitioner;
  initialAdditional?: CodeSearchResult[];
  initialNote?: string;
}

export function referralDialogSeed(
  editPayload: CodedOrderPayload | undefined,
  itemTarget: ReferralTargetInput | undefined,
): ReferralDialogSeed {
  if (editPayload?.kind !== 'referral') return { target: itemTarget };
  const target: ReferralTargetInput | undefined = editPayload.targetSpecialityId
    ? { name: editPayload.targetSpecialityName ?? editPayload.target ?? '', code: editPayload.targetSpecialityId }
    : editPayload.performerRole
    ? { name: editPayload.target ?? '', code: editPayload.performerRole }
    : editPayload.target
      ? { name: editPayload.target }
      : itemTarget;
  return {
    target,
    initialPractitioner: editPayload.targetPractitionerId
      ? { id: editPayload.targetPractitionerId, name: editPayload.targetDisplay ?? '' }
      : undefined,
    initialAdditional: editPayload.additionalDiagnoses?.map((d) => ({
      id: d.code || d.displayName,
      code: d.code,
      display: d.displayName,
      system: d.system,
    })),
    initialNote: editPayload.note,
  };
}
